import UserProfileController from './userProfileController';
import './userProfile.scss';

const UserProfileComponent = {
    template: require('./userProfileView.html'),
    controller: UserProfileController,
    bindings: {
        user: '=',
        onSuccess: '&'
    },
};

export default UserProfileComponent;




// WEBPACK FOOTER //
// ./src/app/pages/user/list/profile/userProfileComponent.js